<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_edit_group_information'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="220px" >
                        <div class="dialog-form-item"></div>
                        <el-form-item prop="talkgroupName" ref="talkgroupName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_groupId'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_groupId')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="talkgroupName" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.talkgroupName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheck('talkgroupName')"/>
                        </el-form-item>
                        <el-form-item prop="displayName" ref="displayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_groupDisplayName'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_group_displayName')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="displayName" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheck('displayName')"/>
                        </el-form-item>
                        <!--- 通話データ保存 --->
                        <el-form-item prop="saveVoice" ref="saveVoice">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_save_voice'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_save_voice')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                <el-select class="select-option-item" v-model="groupOptions.saveVoice" @change="setButtonStatus()" :disabled="appData.e2eEncryption">
                                    <el-option v-for="saveOption in saveOptions" :key="saveOption.displayName" :label="saveOption.displayName" :value="saveOption.value"></el-option>
                                </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <!--- データの保存先 --->
                        <el-form-item prop="storageSelection" ref="storageSelection">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_data_storage'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_storage_selection')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="selectedStorageIndex" @change="setButtonStatus()" :disabled="storageCandidates.length == 1">
                                <el-option v-for="(candidate, index) in storageCandidates" :key="candidate.name" :label="candidate.name" :value="index"></el-option>
                            </el-select>
                        </el-form-item>
                        <!---- 通話自動終了 ---->
                        <el-form-item prop="durationLimit" ref="durationLimit">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_talk_timer'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_talk_timer1'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="durationLimit" class="input-text-talkgroup" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.durationLimit.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheck('durationLimit')"/>
                        </el-form-item>
                        <!---- 発話予約再生待機 ---->
                        <el-form-item v-if="FEATURE_BD_2018_RESERVE_TALK && isReserveTalkAppsEnabled" prop="reserveTalkPlaybackWait" ref="reserveTalkPlaybackWait">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_reserve_talk_playback_wait'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_reserve_talk_playback_wait'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="reserveTalkPlaybackWait" class="input-text-talkgroup" type="text" :disabled="isReserveTalkPlaybackWaitDisabled" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.reserveTalkPlaybackWait.value"
                                 @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                 clearable @clear="inputCheck('reserveTalkPlaybackWait')"/>
                        </el-form-item>
                        <!--- 通話形式 --->
                        <el-form-item prop="talkType" ref="talkType">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_talk_type'"></span> <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_talk_type')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="talkType" @change="setButtonStatus()">
                                <el-option v-for="talkType in talkTypeList" :label="talkType.label" :value="talkType.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <!--- かんたんログイン --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_easyLogin'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left">
                                        <div style="font-weight:bolder; font-size:14px" v-t="'message.item_option_easyLogin_selection'"></div>
                                        <div style="margin-top:4px" v-html="$t('message.hint_easy_login_selection')"></div>
                                        <div style="font-weight:bolder; font-size:14px; margin-top:20px" v-t="'message.item_option_easyLogin_random'"></div>
                                        <div style="margin-top:4px" v-html="$t('message.hint_easy_login_random')"></div>
                                    </div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select class="select-option-item" v-model="groupOptions.easyLogin" @change="setButtonStatus()">
                                <el-option v-for="easyLoginType in easyLoginTypeList" :label="easyLoginType.label" :value="easyLoginType.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <!--- 低ビットレートモード --->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_lowBitRate'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <span slot="content" style="text-align:left" v-t="'message.hint_option_lowBitRate'"></span>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.lowBitRate" active-color="#5171cb" @change="handleOptionChange('lowBitRate')"></el-switch>
                        </el-form-item>
                        <!--- 位置情報 --->
                        <el-form-item v-if="isVisibleGroupOption('location')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_location_information'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <span slot="content" style="text-align:left" v-t="'message.hint_option_locationInGroup'"></span>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.location" active-color="#5171cb" @change="handleOptionChange('location')"></el-switch>
                        </el-form-item>
                        <!--- MAP通話オプション --->
                        <el-form-item v-if="isVisibleGroupOption('mapTalk')" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_map_talk'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <span slot="content" style="text-align:left" v-t="'message.hint_option_map_talk'"></span>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.mapTalk" active-color="#5171cb" @change="handleOptionChange('mapTalk')"></el-switch>
                        </el-form-item>
                        <!--- サブグループオプション --->
                        <el-form-item v-if="appData.enableSubgroupOption" style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_option_subGroup'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-t="'message.hint_option_subGroup'"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-switch v-model="groupOptions.subGroup" active-color="#5171cb" @change="handleOptionChange('subGroup')"></el-switch>
                        </el-form-item>

                        <div v-if="showOptionSetting">
                            <!--- hide all options when online purchase / speech-to-text license not exist ---->
                            <p class="beside-line" v-t="'message.item_option'"></p>
                            <p class="option-description">
                                <span v-if="appData.basicContract.planType == 0" v-t="'message.hint_option_description1'"/>
                                <span v-else v-t="'message.hint_option_description1_plan'"/>
                                <br>
                                <span v-t="'message.hint_option_description5'"/><br>
                                <span>
                                    <span v-t="'message.hint_option_description7_1'"/>
                                    <a href="javascript:void(0);" style="text-decoration:none" @click="$emit('showManual')"><span v-t="'message.menu_manual'"/></a>
                                    <span v-t="'message.hint_option_description7_2'"/>
                                </span>
                            </p>
                            <!--- 音声テキスト化オプション --->
                            <el-form-item v-if="isVisibleGroupOption('speechToTextEngine')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_speechToText'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-t="'message.hint_option_speechToText'">
                                        </div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                    <el-select class="select-option-item" v-model="groupOptions.speechToTextEngine" @change="handleOptionChange('speechToTextEngine')" :disabled="appData.e2eEncryption">
                                        <el-option v-for="speechEngine in speechEngineList" :key="speechEngine.type" :label="speechEngine.displayName" :value="speechEngine.type"/>
                                    </el-select>
                                </el-tooltip>
                            </el-form-item>
                            <!--- 音声テキスト化対応言語 --->
                            <div slot="label" class="language-option-container">
                                <div class="language-header">
                                    <span class="language-title" v-t="'message.manual_item_language'" v-on:click="sttExpanded = !sttExpanded" style="cursor: pointer;"></span>
                                    <button v-if="!sttExpanded" class="transparent" type="button" v-on:click="sttExpanded = true"><i class="el-icon-arrow-down"></i></button>
                                    <button v-else class="transparent" type="button" v-on:click="sttExpanded = false"><i class="el-icon-arrow-up"></i></button>
                                </div>
                                <template v-if="sttExpanded">
                                    <div class="engine-list">
                                        <div class="engine-item" v-for="(engine, index) in sttEngineDescriptions" :key="index">
                                            <div class="engine-name">
                                                <span v-t="engine.name"></span>
                                            </div>
                                            <div class="engine-description">
                                                <span v-t="engine.description"></span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <!--- 翻訳オプション --->
                            <el-form-item v-if="isVisibleGroupOption('translationEngine')" style="text-align:right">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_option_translation'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_option_translation')">
                                        </div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                    <el-select class="select-option-item" v-model="groupOptions.translationEngine" @change="handleOptionChange('translationEngine')" :disabled="appData.e2eEncryption">
                                        <el-option v-for="translationEngine in translationEngineList" :key="translationEngine.type" :label="translationEngine.displayName" :value="translationEngine.type"></el-option>
                                    </el-select>
                                </el-tooltip>
                            </el-form-item>
                            <!--- 翻訳対応言語 --->
                            <div slot="label" class="language-option-container">
                                <div class="language-header">
                                    <span class="language-title" v-t="'message.manual_item_language'" v-on:click="translationExpanded = !translationExpanded" style="cursor: pointer;"></span>
                                    <button v-if="!translationExpanded" class="transparent" type="button" v-on:click="translationExpanded = true"><i class="el-icon-arrow-down"></i></button>
                                    <button v-else class="transparent" type="button" v-on:click="translationExpanded = false"><i class="el-icon-arrow-up"></i></button>
                                </div>
                                <template v-if="translationExpanded">
                                    <div class="engine-list">
                                        <div class="engine-item" v-for="(engine, index) in translationEngineDescriptions" :key="index">
                                            <div class="engine-name">
                                                <span v-t="engine.name"></span>
                                            </div>
                                            <div class="engine-description">
                                                <span v-t="engine.description"></span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <template v-if="isVisibleGroupOption('video')">
                                <!--- ライブキャストオプション --->
                                <el-form-item style="text-align:right">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_option_video'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <span slot="content" style="text-align:left" v-t="'message.hint_option_video'"></span>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-switch v-model="groupOptions.video" active-color="#5171cb" @change="handleOptionChange('video')"></el-switch>
                                </el-form-item>
                                <!--- ライブキャスト保存 --->
                                <el-form-item prop="saveLivecast" ref="saveLivecast">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_save_livecast'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-html="$t('message.hint_save_livecast')"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-tooltip :content="$t('message.hint_option_not_available_when_encrypted')" placement="top" :disabled="!appData.e2eEncryption">
                                        <el-select class="select-option-item" :disabled="appData.e2eEncryption || !groupOptions.video" v-model="groupOptions.saveLivecast" @change="setButtonStatus()">
                                            <el-option v-for="saveOption in saveOptions" :key="saveOption.displayName" :label="saveOption.displayName" :value="!appData.e2eEncryption && saveOption.value"></el-option>
                                        </el-select>
                                    </el-tooltip>
                                </el-form-item>
                                <!--- ライブキャスト自動終了 --->
                                <el-form-item ref="videoDurationLimit" prop="videoDurationLimit">
                                    <div slot="label" style="text-align:left">
                                        <span v-t="'message.item_video_timer'"></span>
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div slot="content" style="text-align:left" v-t="{ path: 'message.hint_video_timer', args: { max: getMaxVideoDurationLimit() } }"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </div>
                                    <el-input id="videoDurationLimit" class="input-text-talkgroup" type="text" :disabled="!groupOptions.video" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.videoDurationLimit.value"
                                         @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                         clearable @clear="inputCheck('videoDurationLimit')"/>
                                </el-form-item>
                            </template>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="saveChange()" :disabled="this.$data.disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';
import processorTemplateUtil from './pc/setting/ai-app/AiAppSettingUtil.js';
import { FEATURE_BD_2018_RESERVE_TALK } from "@/components/feature_toggles/feature_toggle";
import { FEATURE_BD_1862_LONG_LIVECAST } from "@/components/feature_toggles/feature_toggle";

export default {
    data() {
        return {
            speechEngineList: [],
            translationEngineList: [],
            saveOptions: [],
            storageCandidates: [],
            talkTypeList: [],
            easyLoginTypeList: [],

            processorDefinitionNeedsStt: false,
            disableButton: false,
            sttExpanded: false,
            translationExpanded: false,
            sttEngineDescriptions: (this.appData.basicContract.planType != 0) ?
            [
                { name: 'message.item_auto', description: 'message.hint_stt_engine_auto' },
                { name: 'message.item_amivoice', description: 'message.hint_stt_engine_amivoice' },
                { name: 'message.item_azure_speechToText', description: 'message.hint_stt_engine_azure' }
            ] :
            [
                { name: 'message.item_auto', description: 'message.hint_stt_engine_auto' },
                { name: 'message.item_amivoice', description: 'message.hint_stt_engine_amivoice' },
                { name: 'message.item_azure_speechToText', description: 'message.hint_stt_engine_azure' },
                { name: 'message.item_google_speechToText', description: 'message.hint_stt_engine_google' }
            ],
            translationEngineDescriptions: [
                { name: 'message.item_auto', description: 'message.hint_translation_engine_auto' },
                { name: 'message.item_azure_translate', description: 'message.hint_translation_engine_azure' },
                { name: 'message.item_google_translate', description: 'message.hint_translation_engine_google' },
                { name: 'message.item_deepl_translate', description: 'message.hint_translation_engine_deepl' }
            ],

            inputForm: {
                talkgroupName:              { validationRule: "objectId",       valid: true, value: null,   isComposing: false },
                displayName:                { validationRule: "reqDisplayName", valid: true, value: null,   isComposing: false },
                durationLimit:              { validationRule: "numeric",        valid: true, value: 0,      isComposing: false },
                videoDurationLimit:         { validationRule: "numeric",        valid: true, value: 0,      isComposing: false },
                reserveTalkPlaybackWait:    { validationRule: "numeric",        valid: true, value: 3,      isComposing: false },
            },
            talkType: null,
            groupOptions: {
                speechToTextEngine:     0,
                translationEngine:      0,
                saveVoice:              true,
                saveLivecast:           true,
                location:               false,
                mapTalk:                false,
                video:                  false,
                lowBitRate:             false,
                subGroup:               false,
                easyLogin:              0,
            },
            savedEngine: {
                speechToTextEngine: 0,
                translationEngine: 0,
            },
            selectedStorageIndex: 0,
        };
    },
    created: function() {
        if (this.appData.basicContract.planType != 0) {
            this.speechEngineList = commonUtil.getSpeechToTextEngineListForPlanLicense(this.$i18n);

            // If Google Speech To Text is already selected, add it to the list
            if (this.talkgroupAttribute.talkgroupOptions.speechToTextEngine === 2) {
                const googleStt = commonUtil.getSpeechToTextEngineList(this.$i18n).find(engine => engine.type === 2);
                if (googleStt) {
                    this.speechEngineList.push(googleStt);
                }
            }
        } else {
            this.speechEngineList = commonUtil.getSpeechToTextEngineList(this.$i18n);
        }
        this.translationEngineList = commonUtil.getTranslationEngineList(this.$i18n);

        this.saveOptions = commonUtil.getSaveOptions(this.$i18n);

        this.inputForm.talkgroupName.value = this.talkgroupAttribute.name
        this.inputForm.displayName.value = this.talkgroupAttribute.displayName
        this.inputForm.durationLimit.value = this.talkgroupAttribute.durationLimit;
        this.inputForm.videoDurationLimit.value = this.talkgroupAttribute.videoDurationLimit;
        if (FEATURE_BD_2018_RESERVE_TALK) {
            this.inputForm.reserveTalkPlaybackWait.value = this.talkgroupAttribute.reserveTalkPlaybackWait != null ? this.talkgroupAttribute.reserveTalkPlaybackWait : 3;
        }

        if (this.talkgroupAttribute.talkgroupOptions.multi) {
            this.talkType = 'multi'
        } else if (this.talkgroupAttribute.talkgroupOptions.interrupt) {
            this.talkType = 'interrupt'
        }

        this.groupOptions.saveVoice = this.talkgroupAttribute.talkgroupOptions.saveVoice;
        this.groupOptions.saveLivecast = this.talkgroupAttribute.talkgroupOptions.saveLivecast;
        this.groupOptions.location = this.talkgroupAttribute.talkgroupOptions.location;
        this.groupOptions.speechToTextEngine = this.savedEngine.speechToTextEngine = this.talkgroupAttribute.talkgroupOptions.speechToTextEngine;
        this.groupOptions.translationEngine = this.savedEngine.translationEngine = this.talkgroupAttribute.talkgroupOptions.translationEngine;
        this.groupOptions.mapTalk = this.talkgroupAttribute.talkgroupOptions.mapTalk;
        this.groupOptions.video = this.talkgroupAttribute.talkgroupOptions.video;
        this.groupOptions.lowBitRate = this.talkgroupAttribute.talkgroupOptions.lowBitRate;
        this.groupOptions.easyLogin = this.talkgroupAttribute.talkgroupOptions.easyLogin;

        // check whether processor definition needs Speech to Text
        for (let processorDefinitionId of this.talkgroupAttribute.processorDefinitionIds) {
            let targetDefinition = null;
            for (let definition of this.$root.store.processorDefinitionList) {
                if (processorDefinitionId == definition.id) {
                    targetDefinition = definition;
                    break;
                }
            }
            if (targetDefinition == null) {
                // this must not happen
                continue;
            }
            if (processorTemplateUtil.needStt(targetDefinition.definition)) {
                this.processorDefinitionNeedsStt = true;
                break;
            }
        }

        // selection of storage
        let storageCandidatesAndIndex = processorTemplateUtil.createStorageCandidateArray(this.$i18n, this.$root.store.processorDefinitionList, this.targetStorage);
        this.storageCandidates = storageCandidatesAndIndex.storageCandidates;
        this.selectedStorageIndex = storageCandidatesAndIndex.selectedStorageIndex;

        this.groupOptions.subGroup = this.talkgroupAttribute.talkgroupOptions.subGroup;

        this.talkTypeList = commonUtil.getTalkTypeList(this.$i18n);
        this.easyLoginTypeList = commonUtil.getEasyLoginTypeList(this.$i18n);

        this.disableButton = true;
    },
    mounted: function() {
        // tabIndex of tooltip was always set to 0 (Should set -1 to skip focus)
        for (let element of document.getElementsByClassName('icon-help')) {
            element.setAttribute("tabIndex", "-1");
        }
    },
    computed: {
        FEATURE_BD_2018_RESERVE_TALK() {
            return FEATURE_BD_2018_RESERVE_TALK;
        },
        FEATURE_BD_1862_LONG_LIVECAST() {
          return FEATURE_BD_1862_LONG_LIVECAST;
        },
        isReserveTalkAppsEnabled() {
            return commonUtil.isReserveTalkEnabled(this.appData.apps);
        },
        isReserveTalkPlaybackWaitDisabled: function() {
            return !commonUtil.isReserveTalkEnabled(this.appData.apps);
        },
        showOptionSetting: function() {
            if (this.appData.onlinePurchase) {
                if (this.appData.basicContract.planType != constants.LICENSE_PLAN_SEPARATE) {
                    return true;
                } else {
                    if (this.appData.isRadioIntegrated
                        || (this.appData.enableSpeechTextOption)
                        || (this.appData.enableSpeechTextTrial)) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return true;
            }
        }
    },
    methods: {
        isLongLivecastEnabled() {
            if (!this.FEATURE_BD_1862_LONG_LIVECAST) {
                return false;
            }
            return (this.appData.tenantOption & constants.LONG_LIVECAST) !== 0;
        },
        getMaxVideoDurationLimit() {
            return this.isLongLivecastEnabled() ? 14400 : 3600;
        },
        getVideoDurationUpperLimitMessage(maxLimit) {
            return this.$t('message.error_validate_video_duration_higher_limit', { max: maxLimit.toLocaleString() });
        },
        saveChange: function() {
            for(var validateItem in this.inputForm) {
                this.inputCheck(validateItem);
            }
            if (commonValidate.checkFormValidation(this.inputForm)) {
                let newTalkGroupOptions = {};
                let newAiDefinitionIds = null;

                let originalTalkType = null;
                if (this.talkgroupAttribute.talkgroupOptions.multi) {
                    originalTalkType = 'multi'
                } else if (this.talkgroupAttribute.talkgroupOptions.interrupt) {
                    originalTalkType = 'interrupt'
                }
                if (originalTalkType != this.talkType) {
                    if (this.talkType == 'multi') {
                        newTalkGroupOptions.multi = true;
                        newTalkGroupOptions.interrupt = false;
                    } else if (this.talkType == 'interrupt') {
                        newTalkGroupOptions.multi = false;
                        newTalkGroupOptions.interrupt = true;
                    } else {
                        newTalkGroupOptions.multi = false;
                        newTalkGroupOptions.interrupt = false;
                    }
                }

                if (this.groupOptions.speechToTextEngine != this.talkgroupAttribute.talkgroupOptions.speechToTextEngine) {
                    newTalkGroupOptions.speechToTextEngine = this.groupOptions.speechToTextEngine;
                }
                if (this.groupOptions.translationEngine != this.talkgroupAttribute.talkgroupOptions.translationEngine) {
                    newTalkGroupOptions.translationEngine = this.groupOptions.translationEngine;
                }
                if (this.groupOptions.location != this.talkgroupAttribute.talkgroupOptions.location) {
                    newTalkGroupOptions.location = this.groupOptions.location;
                }
                if (this.groupOptions.mapTalk != this.talkgroupAttribute.talkgroupOptions.mapTalk) {
                    newTalkGroupOptions.mapTalk = this.groupOptions.mapTalk;
                }
                if (this.groupOptions.video != this.talkgroupAttribute.talkgroupOptions.video) {
                    newTalkGroupOptions.video = this.groupOptions.video;
                }
                if (this.groupOptions.lowBitRate != this.talkgroupAttribute.talkgroupOptions.lowBitRate) {
                    newTalkGroupOptions.lowBitRate = this.groupOptions.lowBitRate;
                }
                if (this.groupOptions.subGroup != this.talkgroupAttribute.talkgroupOptions.subGroup) {
                    newTalkGroupOptions.subGroup = this.groupOptions.subGroup;
                }
                if (this.groupOptions.saveVoice != this.talkgroupAttribute.talkgroupOptions.saveVoice) {
                    newTalkGroupOptions.saveVoice = this.groupOptions.saveVoice;
                }
                if (this.groupOptions.saveLivecast != this.talkgroupAttribute.talkgroupOptions.saveLivecast) {
                    newTalkGroupOptions.saveLivecast = this.groupOptions.saveLivecast;
                }
                if (this.groupOptions.easyLogin != this.talkgroupAttribute.talkgroupOptions.easyLogin) {
                    newTalkGroupOptions.easyLogin = this.groupOptions.easyLogin;
                }
                if (Object.keys(newTalkGroupOptions).length == 0) {
                    newTalkGroupOptions = null;
                }
                let selectedStorage = this.storageCandidates[this.selectedStorageIndex];
                let newProcessorDefinitionIds = null;
                let removeProcessorDefinitionIds = null;
                if (this.targetStorage == null) {
                    // larger than 0 means not default
                    if (selectedStorage.value > 0) {
                        newProcessorDefinitionIds = [selectedStorage.value];
                    }
                } else if (this.targetStorage.id != selectedStorage.value) {
                    removeProcessorDefinitionIds = [this.targetStorage.id];
                    if (selectedStorage.value > 0) {
                        newProcessorDefinitionIds = [selectedStorage.value];
                    }
                }

                const savePayload = {
                        name: this.inputForm.talkgroupName.value,
                        displayName: this.inputForm.displayName.value,
                        talkGroupOptions: newTalkGroupOptions,
                        durationLimit: this.inputForm.durationLimit.value,
                        videoDurationLimit: this.inputForm.videoDurationLimit.value,
                        processorDefinitionIds: newProcessorDefinitionIds,
                        removeProcessorDefinitionIds: removeProcessorDefinitionIds,
                };
                if (FEATURE_BD_2018_RESERVE_TALK && this.isReserveTalkAppsEnabled) {
                    savePayload.reserveTalkPlaybackWait = this.inputForm.reserveTalkPlaybackWait.value;
                }
                this.$emit('save', savePayload);
            } else {
                this.disableButton = true;
            }
        },
        setButtonStatus: function() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }

            if (this.$refs[eventTargetId] == null) {
                return;
            }

            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                if (eventTargetId == "reserveTalkPlaybackWait") {
                    if (this.inputForm[eventTargetId].value >= constants.RESERVE_TALK_PLAYBACK_WAIT_MIN && this.inputForm[eventTargetId].value <= constants.RESERVE_TALK_PLAYBACK_WAIT_MAX) {
                        this.inputForm[eventTargetId].valid = true;
                        this.$refs[eventTargetId].clearValidate();
                    } else {
                        this.inputForm[eventTargetId].valid = false;
                        this.$refs[eventTargetId].validateState = "error";
                        if (this.inputForm[eventTargetId].value < constants.RESERVE_TALK_PLAYBACK_WAIT_MIN) {
                            this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_reserve_talk_playback_wait_lower_limit");
                        } else {
                            this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_reserve_talk_playback_wait_higher_limit");
                        }
                    }
                } else if (eventTargetId == "durationLimit" || eventTargetId == "videoDurationLimit") {
                    const maxDurationLimit = eventTargetId == "videoDurationLimit" ? this.getMaxVideoDurationLimit() : 3600;
                    if (this.inputForm[eventTargetId].value >= 1 && this.inputForm[eventTargetId].value <= maxDurationLimit) {
                        this.inputForm[eventTargetId].valid = true;
                        this.$refs[eventTargetId].clearValidate();
                    } else {
                        this.inputForm[eventTargetId].valid = false;
                        this.$refs[eventTargetId].validateState = "error";
                        if (this.inputForm[eventTargetId].value < 1) {
                            this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_duration_lower_limit");
                        } else {
                            if (this.FEATURE_BD_1862_LONG_LIVECAST) {
                                this.$refs[eventTargetId].validateMessage = eventTargetId == "videoDurationLimit"
                                    ? this.getVideoDurationUpperLimitMessage(maxDurationLimit)
                                    : commonUtil.getMessageText(this.$i18n, "error_validate_duration_higher_limit");
                            } else {
                                this.$refs[eventTargetId].validateMessage = commonUtil.getMessageText(this.$i18n,"error_validate_duration_higher_limit");
                            }
                        }
                    }
                } else {
                    this.inputForm[eventTargetId].valid = true;
                    this.$refs[eventTargetId].clearValidate();
                }
            } else {
                this.inputForm[eventTargetId].valid = false;
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
            }
            this.setButtonStatus();
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        handleOptionChange(changedOption) {
            commonUtil.checkChangedGroupOptionCondition(this, changedOption, this.appData, this.groupOptions, this.savedEngine, this.appData.tenantList[0].samlGroup == this.talkgroupAttribute.id, this.processorDefinitionNeedsStt);
            switch (changedOption) {
                case "video":
                    if(!this.appData.e2eEncryption && this.groupOptions.video) {
                        this.groupOptions.saveLivecast = true;
                    } else {
                        if (this.inputForm.videoDurationLimit.value == null) {
                            this.inputForm.videoDurationLimit.value = 60;
                            this.inputCheck('videoDurationLimit');
                        } else if (this.inputForm.videoDurationLimit.value < 0) {
                            this.inputForm.videoDurationLimit.value = 1;
                            this.inputCheck('videoDurationLimit');
                        } else if (this.inputForm.videoDurationLimit.value > this.getMaxVideoDurationLimit()) {
                            this.inputForm.videoDurationLimit.value = this.getMaxVideoDurationLimit();
                            this.inputCheck('videoDurationLimit');
                        }
                        this.groupOptions.saveLivecast = false;
                    }
                    break
                default:
                    break
            }
            this.setButtonStatus();
        },
        isVisibleGroupOption(optionName) {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return commonUtil.isVisibleGroupOption(this.appData.onlinePurchase, optionName);
            } else {
                return true;
            }
        }
    },
    props: [ 'appData' , 'talkgroupAttribute' , 'talkgroupUserCount', 'targetStorage' ]
}
</script>

<style scoped>
.el-select.select-option-item {
    width: 225px;
}

.el-input-number {
    margin-left: 105px;
    width: 120px;
}

.language-option-container {
    padding: 12px 5px 12px 12px;
    margin-bottom: 20px;
    text-align: left;
    background-color: #f6f6f6;
    border-radius: 4px;
    color: rgb(132, 137, 145);
}

.language-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.language-title {
    text-align: left;
    font-size: 12px;
}

.engine-list {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.engine-item {
    flex-wrap: nowrap;
    border-bottom: 1px solid #EBEEF5;
    padding-bottom: 8px;
}

.engine-item:last-child {
    border-bottom: none;
}

.engine-name {
    white-space: normal;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    margin:0 10px 5px 40px;
    word-break: break-word;
}

.engine-name span {
    font-weight: 700;
}

.engine-description {
    white-space: normal;
    text-align: left;
    margin-left: 40px;
    font-size: 12px;
    margin-right: 10px;
    word-break: break-all;
}
</style>
